import { Button, Select, Space } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'

interface Props {
  totalCount: number
  currentPageSize: number
  hasNext: boolean
  hasPrevious: boolean
  currentPage: number
  onNext: () => void
  onPrevious: () => void
  onReset: () => void
  /** When set, the label reads "Page X of N". */
  totalPages?: number
  /** Page-size selector; shown only when both pageSize and onPageSizeChange are set. */
  pageSize?: number
  pageSizeOptions?: readonly number[]
  onPageSizeChange?: (size: number) => void
  disabled?: boolean
}

export function PaginationBar({
  totalCount,
  currentPageSize,
  hasNext,
  hasPrevious,
  currentPage,
  onNext,
  onPrevious,
  onReset,
  totalPages,
  pageSize,
  pageSizeOptions = [10, 20, 50, 100],
  onPageSizeChange,
  disabled,
}: Props) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0' }}>
      <span style={{ color: '#64748b', fontSize: 13 }}>
        Page {currentPage}
        {totalPages !== undefined && ` of ${totalPages}`} · Showing {currentPageSize} of {totalCount}
      </span>
      <Space>
        {pageSize !== undefined && onPageSizeChange && (
          <Select
            size="small"
            aria-label="Rows per page"
            value={pageSize}
            onChange={onPageSizeChange}
            options={pageSizeOptions.map((n) => ({ value: n, label: `${n} / page` }))}
            style={{ width: 110 }}
            disabled={disabled}
          />
        )}
        {hasPrevious && (
          <Button size="small" icon={<LeftOutlined />} onClick={onPrevious} disabled={disabled}>
            Previous
          </Button>
        )}
        {hasPrevious && (
          <Button size="small" onClick={onReset} disabled={disabled}>
            First
          </Button>
        )}
        <Button
          size="small"
          type="primary"
          disabled={disabled || !hasNext}
          icon={<RightOutlined />}
          iconPlacement="end"
          onClick={onNext}
        >
          Next
        </Button>
      </Space>
    </div>
  )
}
